export enum FeatureFlagType {
  THEME_ENABLED = 'themeEnabled',
  GLOBAL_NOTIFICATION_ENABLED = 'globalNotificationEnabled',
  SCHOLAR_ENABLED = 'scholarEnabled',
  SHARED_PROJECTS_ENABLED = 'sharedProjectsEnabled',
  TEAM_PAGE_ENABLED = 'teamPageEnabled',
  PROFILE_SETTINGS_ENABLED = 'profileSettingsEnabled',
  BILLINGS_PAGE_ENABLED = 'billingsEnabled',
  PLATFORM_USAGE_PAGE_ENABLED = 'platformUsageEnabled',
  DASHBOARD_ENABLED = 'dashboardEnabled',
  SALE_ENABLED = 'saleEnabled',
  PROJECTS_ENABLED = 'projectsEnabled',
  VAULT_ENABLED = 'vaultEnabled',
  VAULT_CONTENT_DATE_ENABLED = 'vaultContentDateEnabled',
  AGENTS_ENABLED = 'agentsEnabled',
}
